function $t(state, v, defaultValue) {
    const t = state.translationsRaw || state.customizer?.translationsRaw;

    return t.te(v) ? t.t(v) : defaultValue;
}

// eslint-disable-next-line import/prefer-default-export
export function formatPrice(state, price, notation, excludeCurrency) {
    // eslint-disable-next-line prefer-destructuring
    let locale = state.options.locale;
    locale = (locale ?? '').replace('_', '-');

    // eslint-disable-next-line no-unsafe-optional-chaining
    const currencyBefore = excludeCurrency ? '' : $t(state, 'CUSTOM_CURRENCY_BEFORE', '');
    // eslint-disable-next-line no-unsafe-optional-chaining
    const currencyAfter = excludeCurrency ? '' : $t(state, 'CUSTOM_CURRENCY_AFTER', '');
    // eslint-disable-next-line no-unsafe-optional-chaining
    let currencyDigits = +$t(state, 'CUSTOM_CURRENCY_DIGITS_SHORT', '0');

    // Override the translations table and prevent conflicts with any legacy stuff using "compact"
    if (notation === 'noDigits') {
        currencyDigits = 0;
    }

    if (notation === 'standard') {
        currencyDigits = +$t(state, 'CUSTOM_CURRENCY_DIGITS_LONG', '2');
    }
    // eslint-disable-next-line no-unsafe-optional-chaining
    const useCurrency = $t(state, 'CURRENCY', null) ?? 'USD';

    if (currencyBefore?.length > 0 || currencyAfter?.length > 0) {
        const priceFormatted = new Intl.NumberFormat(locale, {
            style: 'decimal',
            minimumFractionDigits: currencyDigits,
        }).format(price);

        return `${currencyBefore}${priceFormatted}${currencyAfter}`.replace(/<space>/g, ' ');
    }

    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: useCurrency,
        notation: notation ?? 'compact',
    }).format(price);
}
